import React from 'react';
import { differenceInDays } from 'date-fns';

interface Args {
	openedDate: Date;
	backDate?: Date;
	outDate?: Date;
	openDate: Date;
}

export const useCenteredDayIndex = ({ openedDate, backDate, outDate, openDate }: Args) => {
	return React.useCallback(
		(minDate: Date): number => {
			if (openedDate) {
				return differenceInDays(openedDate, minDate);
			} else if (backDate) {
				return differenceInDays(backDate, minDate);
			} else if (outDate) {
				return differenceInDays(outDate, minDate);
			}

			return differenceInDays(openDate, minDate);
		},
		[openedDate, backDate, outDate, openDate]
	);
};
